import { SelectedItemType } from "@store/Outstanding";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Swal from "sweetalert2";
import { toJS } from "mobx";
import { useHistory } from "react-router-dom";
import { cast } from "mobx-state-tree";

interface usePaymentProps {
  getAllData: (limit: number) => Promise<void>;
  setSelectItemsInvoice: (x: SelectedItemType[]) => void;
  selectedItemsInvoice: SelectedItemType[];
}

const usePayment = ({
  getAllData,
  setSelectItemsInvoice,
  selectedItemsInvoice,
}: usePaymentProps) => {
  const history = useHistory();
  const [messageError, setMessageError] = useState("");

  const handleInvoiceItemClick = useCallback(
    (OutstandingItem: SelectedItemType) => {
      let creaditNoteItems: SelectedItemType[] = [];
      let invoiceItems: SelectedItemType[] = [];
      let tempMessageError = "";
      /* Finding the index of the selected item in the array of selected items. */

      const findIndex = selectedItemsInvoice.findIndex(
        (selectedItem) =>
          selectedItem.accountingDocumentId ===
          OutstandingItem.accountingDocumentId
      );
      let tempSelectedItem: SelectedItemType[] = [...selectedItemsInvoice];
      if (findIndex > -1) {
        tempSelectedItem.splice(findIndex, 1);
      } else {
        // item set null because error in mst
        tempSelectedItem.push(toJS(OutstandingItem));
      }

      /* Separating the credit note and invoice items. */
      tempSelectedItem.forEach((item) => {
        if (item.type === "credit_note") {
          creaditNoteItems.push({ ...item, error: false, reductionId: null });
        } else {
          invoiceItems.push({ ...item, error: false, reductionId: null });
        }
      });

      /* If there is no invoice, it will show an error message. */
      if (invoiceItems.length === 0) {
        creaditNoteItems.forEach((_, index) => {
          creaditNoteItems[index].error = true;
        });
        setMessageError("Error, please contact Customer Service.");
        setSelectItemsInvoice([...invoiceItems, ...creaditNoteItems]);
        return;
      }

      const totalPay = calculationTotal(tempSelectedItem);

      console.log("TOTAL PAY", totalPay);

      /* Checking if the total price is less than .5, it will show an error message. */
      if (totalPay !== 0 && totalPay < 150) {
        creaditNoteItems.forEach((_, index) => {
          creaditNoteItems[index].error = true;
        });
        invoiceItems.forEach((_, index) => {
          invoiceItems[index].error = true;
        });
        setMessageError(
          "Total price must be more than $1.5,  please contact Customer Service."
        );
        setSelectItemsInvoice([...invoiceItems, ...creaditNoteItems]);
        return;
      }

      /* Sorting the invoiceItems array by the remainingAmount property. */
      invoiceItems = invoiceItems.sort((a, b) => {
        if (b.remainingAmount && a.remainingAmount) {
          return b.remainingAmount - a.remainingAmount;
        }
        return 0;
      });

      /* Sorting the invoiceItems array by the remainingAmount property. */
      creaditNoteItems = creaditNoteItems.sort((a, b) => {
        if (b.remainingAmount && a.remainingAmount) {
          return b.remainingAmount - a.remainingAmount;
        }
        return 0;
      });

      /* This is the logic for the payment. */
      for (let i = 0; i < invoiceItems.length; i++) {
        let subtractionAmountInvoice = invoiceItems[i].remainingAmount;
        for (let j = 0; j < creaditNoteItems.length; j++) {
          const remainingAmountCreaditNote =
            creaditNoteItems[j].remainingAmount;
          if (
            subtractionAmountInvoice &&
            remainingAmountCreaditNote &&
            !creaditNoteItems[j].reductionId
          ) {
            const resultpay =
              subtractionAmountInvoice - remainingAmountCreaditNote;
            if (resultpay >= 0) {
              creaditNoteItems[j].reductionId =
                invoiceItems[i].accountingDocumentId;
              subtractionAmountInvoice = resultpay;
            }
          }
        }
      }

      // check reductionId
      if (
        creaditNoteItems.findIndex((item) => item.error || !item.reductionId) >
        -1
      ) {
        creaditNoteItems.forEach((_, index) => {
          creaditNoteItems[index].error = true;
        });
        tempMessageError = "Error, please contact Customer Service.";
      }

      setMessageError(tempMessageError);
      console.log("Test", [...invoiceItems, ...creaditNoteItems]);
      setSelectItemsInvoice([...invoiceItems, ...creaditNoteItems]);
    },
    [selectedItemsInvoice]
  );

  console.log(selectedItemsInvoice);

  const calculationTotal = useCallback((items: SelectedItemType[]) => {
    let total = 0;
    items.forEach((item) => {
      if (item.type === "credit_note") {
        total -= item?.remainingAmount || 0;
      } else if (item.type === "invoice") {
        total += item?.remainingAmount || 0;
      }
    });
    return total;
  }, []);

  /* A callback function that is used to check the payment. */
  const handePayment = useCallback(
    (callback: () => void) => {
      const totalPay = calculationTotal(selectedItemsInvoice);

      if (selectedItemsInvoice.find((item) => item.error === true)) {
        Swal.fire("Unable to Pay, Please Contact Admin");
        return;
      }
      if (selectedItemsInvoice.length === 0) {
        Swal.fire("Please Select Invoices");
        return;
      }

      if (totalPay <= 0) {
        Swal.fire("Unable to Pay, Please Contact Admin");
        return;
      }

      if (totalPay <= 100 && totalPay > 0) {
        Swal.fire("Unable to Pay, Please Contact Admin");
        return;
      }

      callback();
    },
    [selectedItemsInvoice]
  );

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const referance = query.get("reference");
    const status = query.get("status");
    console.log(history);
    if (referance && status) {
      console.log(history);
      query.delete("reference");
      query.delete("status");
      history.replace({
        search: query.toString(),
      });
      getAllData(2000);
    }
  }, [location, history]);

  return {
    selectedItemsInvoice,
    setSelectItemsInvoice,
    handleInvoiceItemClick,
    handePayment,
    calculationTotal,
    messageError,
  };
};

export default usePayment;
